import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-76">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-77">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/80 via-[#0A0A0A]/60 to-[#0A0A0A] z-10" data-id="element-78" />
        <img src="https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?w=1600&q=80" alt="Premium Gaming Collectible" className="w-full h-full object-cover opacity-60" data-id="element-79" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-80">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-81">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="space-y-8" data-id="element-82">
            <div className="inline-flex items-center space-x-2 border border-[#C9A962]/30 bg-[#0A0A0A]/50 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-83">
              <span className="w-2 h-2 bg-[#C9A962] rounded-full animate-pulse" data-id="element-84"></span>
              <span className="text-[#C9A962] text-xs font-mono tracking-widest uppercase" data-id="element-85">
                Ecliptic Edition Drop Live
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold text-[#F5F5F0] leading-tight" data-id="element-86">
              Curated for <br data-id="element-87" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#C9A962] to-[#F5F5F0]" data-id="element-88">
                Collectors
              </span>
            </h1>

            <p className="text-lg md:text-xl text-[#F5F5F0]/70 max-w-lg leading-relaxed" data-id="element-89">
              Discover authenticated, limited-edition gaming artifacts. Premium
              preservation for the discerning enthusiast.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-90">
              <Button size="lg" className="group" data-id="element-91">
                View Collection
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-92" />
              </Button>
              <Button variant="outline" size="lg" data-id="element-93">
                Join Zenith Tier
              </Button>
            </div>

            <div className="flex items-center space-x-8 pt-8 border-t border-[#F5F5F0]/10" data-id="element-94">
              <div data-id="element-95">
                <p className="text-[#C9A962] font-mono text-2xl" data-id="element-96">047</p>
                <p className="text-[#F5F5F0]/50 text-xs uppercase tracking-wider" data-id="element-97">
                  Remaining
                </p>
              </div>
              <div className="h-8 w-px bg-[#F5F5F0]/10" data-id="element-98"></div>
              <div data-id="element-99">
                <div className="flex items-center space-x-2 text-[#F5F5F0]" data-id="element-100">
                  <Clock size={16} className="text-[#C9A962]" data-id="element-101" />
                  <p className="font-mono text-lg" data-id="element-102">04:23:12</p>
                </div>
                <p className="text-[#F5F5F0]/50 text-xs uppercase tracking-wider" data-id="element-103">
                  Until Close
                </p>
              </div>
            </div>
          </motion.div>

          {/* Hero Image/Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="hidden lg:block relative" data-id="element-104">
            <div className="relative z-10 rounded-lg overflow-hidden border border-[#F5F5F0]/10 shadow-2xl shadow-[#C9A962]/10" data-id="element-105">
              <img src="https://images.unsplash.com/photo-1552820728-8b83bb6b773f?w=800&q=80" alt="Limited Edition Controller" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700" data-id="element-106" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0A0A0A] to-transparent p-8" data-id="element-107">
                <p className="text-[#C9A962] font-mono text-sm mb-1" data-id="element-108">
                  Series 01
                </p>
                <h3 className="text-2xl font-serif text-[#F5F5F0]" data-id="element-109">
                  Phantom Aegis Controller
                </h3>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#C9A962]/10 rounded-full blur-3xl -z-10" data-id="element-110"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#6B2D3C]/20 rounded-full blur-3xl -z-10" data-id="element-111"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}